<template>
  <div class="calendar-controls-bar">
    <div class="field has-addons">
      <div class="control">
        <div
          class="button is-primary has-tooltip-bottom"
          @click="goTo('previous')"
          data-tooltip="Pokaż wcześniejsze dni"
        >
          <icon name="fa-chevron-left" />
        </div>
      </div>
      <div class="control">
        <div
          class="button is-primary has-tooltip-bottom"
          @click="goTo('today')"
          data-tooltip="Skocz do dzisiejszej daty"
        >
          <icon name="fa-calendar-day" />
        </div>
      </div>
      <div class="control">
        <div
          class="button is-primary has-tooltip-bottom"
          @click="goTo('next')"
          data-tooltip="Pokaż późniejsze dni"
        >
          <icon name="fa-chevron-right" />
        </div>
      </div>
    </div>
    <div class="field">
      <div
        class="control has-icons has-icons-left has-icons-right has-tooltip-bottom"
        data-tooltip="Skocz do wybranej daty"
      >
        <input type="date" class="input" v-model.trim="customDate" />
        <icon name="fa-calendar-alt" class="is-left" />
        <icon name="fa-arrow-right" class="is-right" />
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";
import { Icon } from "%helpers";

export default {
  name: "calendar-controls-bar",

  components: {
    Icon
  },

  data() {
    return {
      customDate: ""
    };
  },

  methods: {
    goTo(day) {
      this.$emit(day);
      this.customDate = "";
    }
  },

  watch: {
    customDate(value) {
      if (/\d{4}-\d{2}-\d{2}/.test(value)) {
        this.$emit("go-to", dayjs(value));
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.calendar-controls-bar {
  display: flex;

  & > :not(:first-child) {
    margin-left: 1rem;
  }
}
</style>
